import { combineReducers } from 'redux';

import assetPicker from './assetPickerReducer';
import assetRowPicker from './assetRowPickerReducer';
import game from './gameReducer';
import gameGuide from './gameGuideReducer';
import sideBar from './sideBarReducer';
import blokEditor from './blokEditorReducer';
import actionReaction from './actionReactionReducer';
import levelEditor from './levelEditorReducer';
import levelSettings from './levelSettingsReducer';
import gameKit from './gameKitReducer';
import popup from './popupReducer';
import dragDrop from './dragDropReducer';
import bottomBar from './bottomBarReducer';
import user from './userReducer';

export default combineReducers({
    assetPicker,
    assetRowPicker,
    game,
    gameGuide,
    sideBar,
    blokEditor,
    actionReaction,
    levelEditor,
    levelSettings,
    gameKit,
    popup,
    dragDrop,
    bottomBar,
    user
});
